import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import './MobileMenu.css';
import headercalendaricon from "../../../assets/images/headercalendaricon.svg";
import headerchaticon from "../../../assets/images/headerchaticon.svg";
import headerbellicon from "../../../assets/images/headerbellicon.svg";

interface MobileMenuProps {
    hasUnreadMessages: boolean;
    hasUnread: boolean;
    onShowNotifications: () => void;
    onShowChat: () => void;
    showOnDesktop?: boolean;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ hasUnreadMessages, hasUnread, onShowNotifications, onShowChat, showOnDesktop = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Position dropdown relative to button
  useEffect(() => {
    if (isOpen && buttonRef.current && dropdownRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const dropdown = dropdownRef.current;
      // For fixed positioning, use getBoundingClientRect values directly (relative to viewport)
      dropdown.style.top = `${buttonRect.bottom + 8}px`;
      dropdown.style.right = `${window.innerWidth - buttonRect.right}px`;
    }
  }, [isOpen]);

  const handleShowNotifications = () => {
    onShowNotifications();
    setIsOpen(false);
  }

  const handleShowChat = () => {
    onShowChat();
    setIsOpen(false);
  }

  return (
    <div className={`mobile-menu-container ${showOnDesktop ? 'show-on-desktop' : ''}`} ref={menuRef}>
      <button ref={buttonRef} onClick={toggleMenu} className="mobile-menu-button">
        <FontAwesomeIcon icon={faEllipsisV} />
      </button>
      {isOpen && (
        <div ref={dropdownRef} className="mobile-menu-dropdown">
          <ul>
            <li>
                <Link to="/calendar" onClick={() => setIsOpen(false)}>
                    <img src={headercalendaricon} alt="Calendar" />
                    <span>Calendar</span>
                </Link>
            </li>
            <li>
                <button onClick={handleShowNotifications}>
                    <img src={headerbellicon} alt="Notifications" />
                    <span>Notifications</span>
                    {hasUnread && <span className="notification-dot-menu"></span>}
                </button>
            </li>
            <li>
                <button onClick={handleShowChat}>
                    <img src={headerchaticon} alt="Chat" />
                    <span>Chat</span>
                    {hasUnreadMessages && <span className="notification-dot-menu"></span>}
                </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default MobileMenu;
